// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/work-item-comment-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    comment: {
      type: 'string',
      nullable: true,
    },
    createdDate: {
      type: 'string',
      format: 'date-time',
    },
  },
} as IJSONSchema;

export default schema;
